<template>
  <div>
    <!-- <div>
      <b-input-group>
        <b-form-input
          size="sm"
          v-model="search"
          type="search"
          id="filterInput"
          class
          placeholder="Search With Client Name"
        ></b-form-input>
      </b-input-group>
    </div> -->
    <br />
          <div
        v-if="AmendmentDetails.length === 0 && isfetched"
        class="w-100 mx-0 my-2 px-2 d-block alert alert-primary"
        role="alert"
      >No Amendments generated for the selected SOW</div>
    <div v-if="AmendmentDetails.length > 0" class="row">
      <div
        class="col-sm-2 ml-3 d-inline-block sowcard p-0 mb-3 border-info card bg-white text-info"
        v-bind:key="AmendmentDetails.id"
        v-bind:slug="AmendmentDetails.Slug"
        v-for="AmendmentDetails in activeAmendments"
      >
        <div class="lfcard p-1 text-nowrap card-body">
          <div>
            <h6
              class="d-inline-block card-title font-weight-bold"
            >{{ AmendmentDetails.clientName.substr(0, 22) }}</h6>
            <span
              class="badge font-weight-bold"
              v-b-popover.click.top="AmendmentDetails.clientName"
              v-if="AmendmentDetails.clientName.length > 22"
            >...</span>
          </div>
          <div>
            <span class="py-1 px-1 d-inline card mr-1" style="font-size:12px">
              <a :href="AmendmentDetails.amendmentFileInfo.webURl" target="_blank" class="card-link">
                <font-awesome-icon class="mx-1 text-info" :icon="['fas', 'file-word']" size="lg" />SOW
              </a>
              <font-awesome-icon
                class="mx-1"
                :icon="['fas', 'download']"
                @click="handleDownload(AmendmentDetails.amendmentFileInfo)"
                size="sm"
              />
            </span>
            <span style="font-size:12px" v-if="AmendmentDetails.incidentType != 'it-mdr'">Amendment Count -
            {{AmendmentDetails.count}}
            </span>

          </div>
          <div class="p-2 card-footer text-muted">
            <small>
              Created On {{ AmendmentDetails.createdAt |formatDateTime }}
              <br />
              By {{ AmendmentDetails.createdBy ? AmendmentDetails.createdBy.name : "" }}
            </small>
          </div>
          <!-- <a href="#" class="card-link">SoW Details</a> -->
        </div>
      </div>
    </div>
        <font-awesome-icon
      title="Create New"
      class="text-info addSow ml-2"
      :icon="['fas', 'plus-circle']"
      size="5x"
      @click="c()"
    />
  </div>
</template>
<script>
import serviceProxy from "../services/index";
import _ from "lodash";
import moment from "moment";
export default {
  name: "ViewAmendments",
  computed: {
    activeAmendments() {
      return this.AmendmentDetails.filter(post => {
        return (
          post.clientName.toLowerCase().includes(this.search.toLowerCase()) &&
          post.isActive
        );
      });
    }
  },
  created() {
    let that = this;
    that.$root.$emit("progress");
    that.$root.$emit("toast", {
      title: "Fetching Amendments",
      message: "Fetching Amendments"
    });
    let id= this.$route.params.slug;
    serviceProxy.sow
      .getAmendmentSows(that.$store.getters.token,id)
      .then(data => {
        let maindata = data.data.data;
        this.isfetched= true,
        that.AmendmentDetails = maindata;
        that.$root.$emit("done");
        that.$root.$emit("toast", {
          title: "Amendments Fetched",
          message: "Fetched the Amendments"
        });
      })
      .catch(e => {
        console.log(e);
        that.$root.$emit("done");
      });
  },
  methods: {
    handleDownload(fileInfo) {
      let that = this;
      let FileId = fileInfo.fileId;
      let FileName = fileInfo.fileName;
      that.$root.$emit("progress");
      that.$root.$emit("toast", {
        title: "Downloading",
        message: "Downloading SoW",
      });
      serviceProxy.sow
        .download(this.$store.getters.token,  FileId, FileName)
        .then(data => {
          var fileURL = window.URL.createObjectURL(
            new Blob([data.data], { type: "application/octet-stream" })
          );
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", FileName, FileName);
          document.body.appendChild(fileLink);
          fileLink.click();
          document.body.removeChild(fileLink);
          that.$root.$emit("done");
          that.$root.$emit("toast", {
            title: " Document download",
            message: " Document downloaded",
          });
        })
        .catch(e => {
          that.$root.$emit("done");
          that.$root.$emit("toast", {
            title: "OOPS",
            message: "Error downloading"
          });
        });
    },
    getTemplate() {},
        c() {
      this.$root.$emit("init");
      this.$router.push({
        path: "/choose-document"
      });
    }
  },
  data() {
    return {
      AmendmentDetails: [],
      search: "",
      isfetched: false,
    };
  }
};
</script>
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.activelf {
  border-top: 3px solid #17a2b8 !important;
  font-weight: bold;
}
.lfcard {
  border-top: 3px solid transparent;
  cursor: pointer;
}
.lawfirmcard {
  width: auto !important;
}
.sowcard {
  width: 265px;
}
.sowcard .card-footer {
  font-size: 14px;
}
.addSow {
  position: fixed;
  bottom: 10px;
  right: 10px;
}
</style>
